import React, { useState } from "react";
import Assignments from "./teacher/Assignments";
import Notices from "./teacher/Notices";
import Quizzes from "./teacher/Quizzes";
import Plagarism from "./teacher/Plagarism";

const DashboardTeacher = () => {
	const [currentTab, setCurrentTab] = useState(0);

	// 0 - assignment
	// 1 - notices
	// 2 - quizzes
	// 3 - Plagarism

	return (
		<div className="DashboardTeacher">
			<div className="container">
				<div className="tabs">
					<div
						id="tab1"
						onClick={() => setCurrentTab(0)}
						className={`tab ${currentTab === 0 && "selected-tab"}`}>
						Assignments
					</div>
					<div
						id="tab2"
						onClick={() => setCurrentTab(1)}
						className={`tab ${currentTab === 1 && "selected-tab"}`}>
						Notices
					</div>
					<div
						id="tab3"
						onClick={() => setCurrentTab(2)}
						className={`tab ${currentTab === 2 && "selected-tab"}`}>
						Create Quiz
					</div>
					<div
						id="tab4"
						onClick={() => setCurrentTab(3)}
						className={`tab ${currentTab === 3 && "selected-tab"}`}>
						Plagarism Checker
					</div>
				</div>

				{currentTab === 0 ? (
					<Assignments />
				) : currentTab === 1 ? (
					<Notices />
				) : currentTab === 2 ? (
					<Quizzes />
				) : (
					<Plagarism />
				)}
			</div>
		</div>
	);
};

export default DashboardTeacher;
